// extracted by mini-css-extract-plugin
export var cartContainer = "_p7-4";
export var gray = "_p7-1";
export var itemContainer = "_p7-2";
export var itemDetails = "_p7-3";
export var strong = "_p7-0";